import { render, staticRenderFns } from "./GdprConsent.vue?vue&type=template&id=b77e6eb0&scoped=true&lang=pug&"
import script from "./GdprConsent.vue?vue&type=script&lang=js&"
export * from "./GdprConsent.vue?vue&type=script&lang=js&"
import style0 from "./GdprConsent.vue?vue&type=style&index=0&id=b77e6eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77e6eb0",
  null
  
)

export default component.exports